import { adminCommercialFindingApi } from "../api/admin/adminCommercialFindingApi";
import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../api/authApi";
import { brandApi } from "../api/brandApi";
import { chatApi } from "../api/chatApi";
import { dataConfidenceApi } from "../api/dataConfidenceApi";
import { mediaTypeApi } from "../api/mediaTypeApi";
import { productApi } from "../api/productApi";
import { retailerApi } from "../api/retailerApi";
import { scenarioApi } from "../api/scenarioApi";
import { settingsApi } from "../api/settingsApi";
import { subBrandApi } from "../api/subBrandApi";
import { userApi } from "../api/userApi";
import notificationsReducer from "../components/notify/notificationSlice";
import { authListenerMiddleware } from "../middleware/authListenerMiddleware";
import chatReducer from "../slices/chatSlice";
import scenariosReducer from "../slices/scenariosSlice";
import userReducer from "../slices/userSlice";
import workspaceReducer from "../slices/workspaceSlice";
import { adminAppLogApi } from "../api/admin/adminAppLogApi";
import { adminWorkerLogApi } from "../api/admin/adminWorkerLogApi";
import { adminDiagnosticsApi } from "../api/admin/adminDiagnosticsApi";
import { adminKnowledgeInsightApi } from "../api/admin/adminKnowledgeInsightApi";
import { adminChatConversationApi } from "../api/admin/adminChatConversationApi";
import { adminCustomerApi } from "../api/admin/adminCustomerApi";
import { adminUserApi } from "../api/admin/adminUserApi";
import { adminProductApi } from "../api/admin/adminProductApi";
import { adminPriceObservationApi } from "../api/admin/adminPriceObservationApi";
import { adminRawSaleRecordApi } from "../api/admin/adminRawSaleRecordApi";
import { adminPromotionEventApi } from "../api/admin/adminPromotionEventApi";
import { adminPromotionTypeApi } from "../api/admin/adminPromotionTypeApi";
import { adminRetailerApi } from "../api/admin/adminRetailerApi";
import { adminSubBrandApi } from "../api/admin/adminSubBrandApi";
import { adminUsageRecordApi } from "../api/admin/adminUsageRecordApi";

export const store = configureStore({
    reducer: {
        chat: chatReducer,
        notifications: notificationsReducer,
        scenarios: scenariosReducer,
        user: userReducer,
        workspace: workspaceReducer,
        [adminAppLogApi.reducerPath]: adminAppLogApi.reducer,
        [adminWorkerLogApi.reducerPath]: adminWorkerLogApi.reducer,
        [adminDiagnosticsApi.reducerPath]: adminDiagnosticsApi.reducer,
        [adminChatConversationApi.reducerPath]: adminChatConversationApi.reducer,
        [adminCustomerApi.reducerPath]: adminCustomerApi.reducer,
        [adminUserApi.reducerPath]: adminUserApi.reducer,
        [adminProductApi.reducerPath]: adminProductApi.reducer,
        [adminPriceObservationApi.reducerPath]: adminPriceObservationApi.reducer,
        [adminRawSaleRecordApi.reducerPath]: adminRawSaleRecordApi.reducer,
        [adminPromotionEventApi.reducerPath]: adminPromotionEventApi.reducer,
        [adminPromotionTypeApi.reducerPath]: adminPromotionTypeApi.reducer,
        [adminRetailerApi.reducerPath]: adminRetailerApi.reducer,
        [adminSubBrandApi.reducerPath]: adminSubBrandApi.reducer,
        [adminUsageRecordApi.reducerPath]: adminUsageRecordApi.reducer,
        [adminCommercialFindingApi.reducerPath]: adminCommercialFindingApi.reducer,
        [adminKnowledgeInsightApi.reducerPath]: adminKnowledgeInsightApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [brandApi.reducerPath]: brandApi.reducer,
        [chatApi.reducerPath]: chatApi.reducer,
        [dataConfidenceApi.reducerPath]: dataConfidenceApi.reducer,
        [mediaTypeApi.reducerPath]: mediaTypeApi.reducer,
        [productApi.reducerPath]: productApi.reducer,
        [retailerApi.reducerPath]: retailerApi.reducer,
        [scenarioApi.reducerPath]: scenarioApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [subBrandApi.reducerPath]: subBrandApi.reducer,
        [userApi.reducerPath]: userApi.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(authListenerMiddleware.middleware)
        .concat(adminAppLogApi.middleware,
            adminWorkerLogApi.middleware,
            adminDiagnosticsApi.middleware,
            adminChatConversationApi.middleware,
            adminCustomerApi.middleware,
            adminUserApi.middleware,
            adminProductApi.middleware,
            adminPriceObservationApi.middleware,
            adminRawSaleRecordApi.middleware,
            adminPromotionEventApi.middleware,
            adminPromotionTypeApi.middleware,
            adminRetailerApi.middleware,
            adminSubBrandApi.middleware,
            adminUsageRecordApi.middleware,
            adminCommercialFindingApi.middleware,
            adminKnowledgeInsightApi.middleware,
            authApi.middleware,
            brandApi.middleware,
            chatApi.middleware,
            dataConfidenceApi.middleware,
            mediaTypeApi.middleware,
            productApi.middleware,
            retailerApi.middleware,
            scenarioApi.middleware,
            settingsApi.middleware,
            subBrandApi.middleware,
            userApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
